import { ReactComponent as MessageIcon } from 'assets/images/dashboard/intro/message.svg';
import { ReactComponent as LikeIcon } from 'assets/images/dashboard/intro/like.svg';
import { ReactComponent as EyeIcon } from 'assets/images/dashboard/intro/eye.svg';
import { ReactComponent as HumanIcon } from 'assets/images/dashboard/intro/human.svg';
import { ReactComponent as ClickIcon } from 'assets/images/dashboard/intro/click.svg';
import { ReactComponent as BusketIcon } from 'assets/images/dashboard/intro/busket.svg';

export const ICON_CONFIGS = {
  default: {
    message: MessageIcon,
    like: LikeIcon,
    eye: EyeIcon,
    human: HumanIcon,
  },
  pharmacy: {
    message: BusketIcon,
    like: LikeIcon,
    eye: EyeIcon,
    human: ClickIcon,
  }
};

export const PLATFORM_PATH_MAP = {
  'apteka': 'pharmacy',
};

export const getPlatformType = (path) => {
  const foundPath = Object.keys(PLATFORM_PATH_MAP).find(key => path.includes(key));
  return foundPath ? PLATFORM_PATH_MAP[foundPath] : 'default';
};